import {
    globalMixpanelReporter as _globalMixpanelReporter,
    MixpanelEventsContext as DefaultMixpanelEventsContext,
} from '@fiverr-private/identification_core';
import { MixpanelEventName, AdditionalPropsMap } from './mixpanel.types';

export const globalMixpanelReporter = _globalMixpanelReporter.extend<
    MixpanelEventName,
    DefaultMixpanelEventsContext,
    AdditionalPropsMap
>();

globalMixpanelReporter.enrichContext({ package: '@fiverr-private/identification_marketplace' }, { preserve: true });
